var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-page',[_c('page-image',{attrs:{"imgURL":require('@/assets/img/hero04.jpg'),"title":"Wholesale","subTitle":"卸売り","fontSize":"6rem"}}),_c('section-frame',[_vm._v(" このページは準備中です"),_c('br'),_vm._v("業販につきましてはお問合せください ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }